import { render, staticRenderFns } from "./schoolRecruitment.vue?vue&type=template&id=da2b9d08&scoped=true&"
import script from "./schoolRecruitment.vue?vue&type=script&lang=js&"
export * from "./schoolRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./schoolRecruitment.vue?vue&type=style&index=0&id=da2b9d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2b9d08",
  null
  
)

component.options.__file = "schoolRecruitment.vue"
export default component.exports